// Feature flags (presentation-only). Rollback = set the env var to "false".
// Comms Center 2.0 — Operational Command Center refactor (CC-1..CC-5).
export const COMMS_CENTER_2 =
  (process.env.REACT_APP_COMMS_CENTER_2 ?? "true").toString().toLowerCase() !== "false";
